import { GET_REFERENCE_STOP_REQUESTED } from "../types/types";

export const getReferenceStops = (queryParams) => ({
    type: GET_REFERENCE_STOP_REQUESTED,
    payload: { "queryParams": queryParams }
});